import { Injectable } from "@angular/core";
import { INDRAApiService } from "@ibe.services/api.indra.service";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from 'rxjs';
import { MOCK_STATUS,MOCK_URL_TOTAL_SUMMARY, URL_ROOT,  } from "@ibe.config";
import { INDRATotalSummaryDetails } from '@ibe.models/total_summary.model';

@Injectable({
	providedIn: 'root'
})
export class INDRATotalSummaryService {

	private _observableTotalSummary: BehaviorSubject<INDRATotalSummaryDetails>;
	private _totalSummary: INDRATotalSummaryDetails;
	private _loadingTotalSummaryStatus: BehaviorSubject<string>;

	constructor(private api: INDRAApiService, private http: HttpClient) {
		this._observableTotalSummary = new BehaviorSubject(this._totalSummary);
		this._loadingTotalSummaryStatus = new BehaviorSubject('');
	}

	public INDRA_TotalSummary(pnrNumber): Observable<any> {
		if (MOCK_STATUS.TOTAL_SUMMARY) {
			const response =this.http.get<any>(MOCK_URL_TOTAL_SUMMARY);
			return response;
		} else {
			const URL = `${URL_ROOT}booking/pnrs/${pnrNumber}/fares/breakdown`;
			const response = this.api.INDRA_get<any>(URL);
			return response;
		}
	}

	public INDRA_getObservableTotalSummary() {
		return this._observableTotalSummary;
	}

	public INDRA_getLoadingTotalSummary() {
		return this._loadingTotalSummaryStatus;
	}
}
